// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/card-background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard h1 {
  font-weight: 700;
  font-size: 32px;
  line-height: 37px;
  color: #6b6b6b;
  margin-bottom: 25px;
}
.dashboard_jobs {
  margin-top: 30px;
}
.dashboard_jobs h1 {
  font-weight: 500;
  font-size: 20px;
  line-height: 21px;
  color: #6b6b6b;
}

.tasks_list {
  padding: 10px;
  background-color: white;
  box-shadow: 0px 10px 50px -15px rgba(132, 132, 132, 0.3);
  border-radius: 5px;
}

.rws {
  max-height: 260px;
  height: 100%;
  width: 100%;
}
.rws video {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.15);
}
@media screen and (max-width: 1000px) {
  .rws {
    max-height: 250px;
  }
}
@media screen and (max-width: 767px) {
  .rws {
    margin-top: 15px;
  }
}

.balance {
  position: relative;
  border-radius: 10px;
  padding: 24px 32px;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.15);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  max-height: 260px;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.balance .ant-progress {
  line-height: 0 !important;
}
@media screen and (max-width: 1000px) {
  .balance {
    padding: 10px 20px;
    max-height: 250px;
    margin-bottom: 30px;
  }
}
.balance_pending {
  position: absolute;
  font-size: 17px;
  font-weight: 500;
  color: #ffb12b;
  left: 0;
  top: -22px;
}
.balance_pending b {
  font-weight: 800;
}
.balance svg {
  height: 31px;
}
.balance_currency {
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  color: #6b6b6b;
  text-transform: capitalize;
}
.balance_money {
  position: relative;
  margin: 30px 0;
}
@media screen and (max-width: 1000px) {
  .balance_money {
    margin: 30px 0 5px;
  }
}
.balance_money h6 {
  font-size: 48px;
  font-weight: 500;
  line-height: 56px;
  color: #00955f;
  margin-bottom: 5px;
}
@media screen and (max-width: 1000px) {
  .balance_money h6 {
    font-weight: 500;
    font-size: 25px;
    line-height: 26px;
  }
}
.balance_money p {
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: #6b6b6b;
  margin-bottom: 0 !important;
  line-height: 16px;
}
@media screen and (max-width: 1000px) {
  .balance_money p {
    font-size: 16px;
    line-height: 16px;
  }
}
.balance_info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 5px;
}
@media screen and (max-width: 1000px) {
  .balance_info {
    flex-direction: column;
    justify-content: flex-start;
    align-items: normal;
  }
}
.balance_info p {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #6b6b6b;
  margin-bottom: 0;
}
@media screen and (max-width: 768px) {
  .balance_info p {
    margin-bottom: 8px;
  }
}
.balance_info a {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #00955f;
  transition: 0.2s all;
}
.balance_info a:hover {
  opacity: 0.5;
  transition: 0.2s all;
}

.statistic-dashboard {
  width: 100%;
  height: 100%;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.task_item {
  background-color: transparent;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(182, 182, 182, 0.5);
}
.task_item:last-of-type {
  border-bottom: none !important;
}
.task_item_mobile {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}
.task_item_mobile .anticon:not(.anticon-star) {
  color: #00955f;
  margin-left: 5px;
}
.task_item_mobile .anticon:not(.anticon-star):hover {
  cursor: pointer;
}
.task_item_mobile_key {
  width: 120px;
  font-size: 14px;
  line-height: 16px;
  color: #aeaeae;
  font-weight: 400;
}
.task_item_mobile_value {
  font-size: 15px;
  font-weight: 500;
}
.task_item_description_nav {
  margin: 30px 0;
  font-size: 14px;
  line-height: 16px;
  color: #aeaeae;
}
.task_item img {
  margin-right: 10px;
}
.task_item_type {
  display: flex;
  align-items: center;
}
.task_item_type svg {
  margin-right: 10px;
}
.task_item_type b {
  font-size: 16px;
}
.task_item_title {
  font-size: 16px;
  line-height: 19px;
  color: #6b6b6b;
}
.task_item_title.mobile {
  margin-right: 10px;
}
@media screen and (max-width: 1000px) {
  .task_item_title {
    font-size: 14px;
  }
}
.task_item b {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #6b6b6b;
}
@media screen and (max-width: 1000px) {
  .task_item b {
    font-size: 14px;
  }
}
.task_item_reward .anticon {
  color: #00955f;
  margin-left: 3px;
}
.task_item_reward .anticon:hover {
  cursor: pointer;
}

@media screen and (max-width: 1000px) {
  .myMoney .ant-table-tbody .ant-table-cell {
    padding: 8px 4px !important;
  }
}
.myMoney .transaction_detail .ant-tag {
  width: 80px;
  text-align: center;
}
.myMoney .balance {
  margin-bottom: 20px;
}
@media screen and (max-width: 1000px) {
  .myMoney .balance {
    margin: 10px 0;
  }
}
.myMoney video {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  margin-bottom: 20px;
}
.myMoney h1 {
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: #6b6b6b;
  margin-bottom: 25px;
}
.myMoney .wrapper_for_blocks {
  box-shadow: 0px 10px 50px -15px rgba(132, 132, 132, 0.3);
  height: auto;
  margin-bottom: 15px;
}
@media screen and (max-width: 1000px) {
  .myMoney .wrapper_for_blocks {
    margin-bottom: 0px;
  }
}
.myMoney .wrapper_for_blocks_form {
  height: 100%;
}
.myMoney button {
  margin: 0 auto;
  text-align: center;
  justify-content: center;
  max-width: 60%;
}
.myMoney .ant-table-thead > tr > th {
  background-color: transparent !important;
}
.myMoney_success {
  text-align: center;
  max-width: 282px;
  width: 100%;
  margin: 20px auto 20px;
}
.myMoney_success h2 {
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: #6b6b6b;
}
.myMoney_success img {
  margin: 25px auto 25px;
}
.myMoney_success p {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #6b6b6b;
}
.myMoney_code {
  max-width: 382px;
}
.myMoney_code_wrap {
  display: flex;
  margin-bottom: 30px;
  justify-content: center;
}
.myMoney_code .code_input {
  width: 36px;
  height: 40px;
  border: 1px solid #898989;
  border-radius: 6px;
  margin-right: 8px;
  text-align: center;
  padding: 0;
  font-weight: 600;
  font-size: 18px;
}
.myMoney_code_btn {
  display: flex;
  justify-content: space-between;
}
.myMoney_code_btn button {
  width: 45% !important;
  max-width: 100% !important;
  padding-left: 0;
  padding-right: 0;
  height: 40px !important;
  justify-content: center;
}
.myMoney_code_resend {
  text-align: center;
  display: inline-block;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  cursor: pointer;
  color: #aeaeae;
  margin-top: 30px;
}
.myMoney .link {
  color: #096dd9;
  cursor: pointer;
}
.myMoney .payout_declined {
  display: flex;
  flex-direction: column;
}
.myMoney .payout_declined .ant-tag {
  padding: 6px 15px;
  font-size: 14px;
}
.myMoney .payout_declined button {
  margin: 20px 0 0 0;
}
.myMoney .title {
  margin-bottom: 5px;
}
.myMoney .sub_title {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  color: #aeaeae;
  margin-bottom: 25px;
}
.myMoney_tab_title {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 25px;
}
.myMoney_tab_title_item {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  cursor: pointer;
  margin-right: 20px;
  padding: 5px 30px;
  background-color: rgba(182, 182, 182, 0.5019607843);
  color: #aeaeae;
  transition: all 0.3s;
  border: 1px solid rgba(182, 182, 182, 0.5019607843);
}
.myMoney_tab_title_item.active {
  color: #00955f;
  background-color: white;
  transition: all 0.3s;
}

.myMoney_code_btn {
  display: flex;
  justify-content: space-between;
}
.myMoney_code_btn button {
  width: 45% !important;
  max-width: 100% !important;
  padding-left: 0;
  padding-right: 0;
  height: 40px !important;
}

.transaction_detail {
  padding: 30px 45px;
}
.transaction_detail h2 {
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: #6b6b6b;
  margin-bottom: 60px;
  text-align: center;
}
.transaction_detail_item {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}
.transaction_detail_item p {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #6b6b6b;
  min-width: 90px;
  margin-bottom: 0;
}
.transaction_detail_item b {
  min-width: 90px;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #6b6b6b;
  margin-top: 50px;
}
.transaction_detail button {
  width: 50%;
  margin-top: 30px;
}

.payment {
  text-align: center;
  margin-bottom: 20px;
  background-color: white;
  padding: 40px 20px;
  border-radius: 10px;
}
.payment .payment_confirm {
  width: 450px !important;
}
.payment h1 {
  font-size: 40px;
  margin-bottom: 10px;
}
.payment h1 b {
  color: rgb(20, 123, 192);
}
.payment h4 {
  font-size: 16px;
  margin-bottom: 10px;
}
.payment_btn {
  flex-wrap: nowrap;
  justify-content: space-between;
  margin-top: 50px;
}

.errorboundary {
  padding: 100px 50px;
  text-align: center;
}
.errorboundary h1 {
  font-size: 60px;
  font-weight: 700;
}
.errorboundary img {
  width: 500px;
  height: 350px;
  display: block;
  margin: 20px auto;
}

.ant-tabs-tab {
  font-size: 14px;
  line-height: 16px;
  color: #898989;
}

.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #00955f;
}

.job_info h1 {
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  color: #6b6b6b;
  margin-bottom: 25px;
}
.job_info_btn {
  margin-top: 20px;
  text-align: right;
}
.job_info_job {
  display: flex;
  margin-bottom: 40px;
}
.job_info_job div {
  margin-right: 40px;
}
.job_info_job h3 {
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #6b6b6b;
  margin-bottom: 10px;
}
.job_info_job p {
  font-size: 16px;
  line-height: 19px;
  color: #6b6b6b;
}

.job_detail h1 {
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  color: #6b6b6b;
  margin-bottom: 25px;
}
@media screen and (max-width: 1000px) {
  .job_detail h1 {
    font-size: 20px;
  }
}
.job_detail_item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.job_detail_item_price {
  display: flex;
  align-items: center;
  margin-right: 15px;
}
.job_detail_item_price_icon {
  width: 40px;
  height: 40px;
  margin-right: 7px;
}
.job_detail_item_price_icon svg {
  width: 40px;
  height: 40px;
}
.job_detail_item_price_price {
  font-size: 16px;
  font-weight: 700;
}
.job_detail_item svg {
  font-size: 14px;
  margin-right: 10px;
}
.job_detail_item p {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #6b6b6b;
  margin-right: 15px;
  margin-bottom: 0;
}
@media screen and (max-width: 1000px) {
  .job_detail_item p {
    font-size: 12px;
  }
}
.job_detail_item b {
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: #6b6b6b;
  margin-right: 15px;
  margin-bottom: 0;
}
@media screen and (max-width: 1000px) {
  .job_detail_item b {
    font-size: 14px;
  }
}

.job_unverified {
  text-align: center;
}
.job_unverified h1 {
  font-size: 33px;
  font-weight: 600;
  margin-bottom: 5px;
}
.job_unverified h2 {
  font-size: 25px;
  font-weight: 400;
}
.job_unverified p {
  font-size: 17px;
}
.job_unverified button {
  display: block;
  margin: 25px auto 0;
}

@media screen and (max-width: 1000px) {
  .job_info_modal .ant-modal-content {
    overflow-x: scroll;
  }
}

.createTest h1 {
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 5px;
}
.createTest h6 {
  font-size: 15px;
  font-weight: 400;
}
.createTest .platform_btn {
  width: 100%;
  margin-top: 10px;
}
.createTest_block {
  position: relative;
  padding: 20px;
  margin-bottom: 10px;
  border-radius: 5px;
  background-color: rgba(122, 201, 238, 0.384);
}
.createTest_block_delete {
  position: absolute;
  top: 10px;
  right: 20px;
}
.createTest_block_answer {
  margin: 10px 0;
  padding: 5px;
  display: flex;
  align-items: center;
}
.createTest_block_answer b {
  font-size: 23px;
}
.createTest_add {
  margin-top: 20px;
  border-radius: 5px;
  background-color: rgba(122, 201, 238, 0.384);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s all ease-in-out;
}
.createTest_add:hover {
  transition: 0.2s all ease-in-out;
  background-color: rgba(63, 164, 211, 0.384);
}
.createTest_add b {
  font-size: 40px;
  margin: 0;
  font-weight: 400;
  color: #00955f;
  line-height: 1;
  display: flex;
  align-items: center;
}
.createTest_add b span {
  font-size: 20px;
  margin-left: 20px;
}

.edit-test {
  position: relative;
  height: 100% !important;
  min-height: 78vh;
}
.edit-test h1 {
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 5px;
}
.edit-test h6 {
  font-size: 15px;
  font-weight: 400;
}

.cources {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  min-height: 78vh;
  height: 100%;
}
.cources_top {
  display: flex;
  padding: 20px 20px 0;
  justify-content: space-between;
  margin-bottom: 40px;
  flex-wrap: wrap;
}
.cources_top .ant-progress {
  width: 70%;
}
@media screen and (max-width: 1000px) {
  .cources_top .ant-progress {
    width: 100%;
    margin-bottom: 20px;
  }
}
.cources_nav {
  width: 20%;
  border-right: 1px solid rgba(128, 128, 128, 0.473);
}
@media screen and (max-width: 1000px) {
  .cources_nav {
    display: none;
  }
}
.cources_nav a {
  display: block;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 12px;
  color: #6b6b6b;
}
.cources_nav a.active {
  color: #00955f;
}
.cources_content {
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .cources_content {
    width: 100%;
  }
}
.cources_wrap {
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px;
  gap: 10px;
}

.cource_item {
  margin-bottom: 20px;
  width: calc((100% - 20px) / 3);
  cursor: pointer;
}
@media screen and (max-width: 1000px) {
  .cource_item {
    width: 49%;
  }
}
@media screen and (max-width: 769px) {
  .cource_item {
    width: 100%;
  }
}
.cource_item:hover h1 {
  color: #00955f;
  transition: 0.3s color ease-in-out;
}
.cource_item h1 {
  font-size: 22px;
  margin-bottom: 5px;
  text-align: center;
  transition: 0.3s color ease-in-out;
}
@media screen and (max-width: 769px) {
  .cource_item h1 {
    font-size: 18px;
  }
}
.cource_item img {
  height: 150px;
  width: 100%;
  border-radius: 10px;
}
@media screen and (max-width: 1000px) {
  .cource_item img {
    height: 200px;
  }
}
@media screen and (max-width: 769px) {
  .cource_item img {
    height: 200px;
    object-fit: cover;
  }
}

.course {
  padding: 0 20px;
}
.course_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.course h1 {
  font-size: 26px;
  width: auto;
  margin-bottom: 0;
}
@media screen and (max-width: 769px) {
  .course h1 {
    font-size: 17px;
    width: 100%;
    margin-bottom: 10px;
  }
}
@media screen and (max-width: 769px) {
  .course button {
    margin-bottom: 10px;
  }
}
@media screen and (max-width: 769px) {
  .course iframe {
    height: 300px !important;
  }
}
@media screen and (max-width: 769px) {
  .course object {
    height: 600px !important;
  }
}
.course_navigation_element {
  display: flex;
  align-items: center;
}
.course_navigation_element span {
  margin-left: 10px;
}

.test {
  min-height: 400px;
}
.test_header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 20px;
  background-color: #00955f;
  border-radius: 20px 20px 0 0;
}
@media screen and (max-width: 769px) {
  .test_header {
    padding: 5px;
  }
}
.test_header h1 {
  color: white;
  font-size: 25px;
  margin-bottom: 10px;
  font-weight: 700;
  width: 100%;
  text-align: center;
}
@media screen and (max-width: 700px) {
  .test_header h1 {
    font-size: 17px;
  }
}
.test_main h2 {
  font-weight: 500;
  margin-top: 50px;
  font-size: 30px;
  text-align: center;
}
@media screen and (max-width: 700px) {
  .test_main h2 {
    font-size: 17px;
  }
}
.test_main_answers {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
@media screen and (max-width: 700px) {
  .test_main_answers button span {
    font-size: 14px;
  }
}
.test_main img:not(.preloader) {
  width: 100%;
  max-height: 450px;
}
.test_footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  margin-bottom: 40px;
}
.test_footer .platform_btn {
  width: 50%;
}

.questionItem {
  padding: 20px;
  display: flex;
  align-items: center;
  width: 48%;
}

.checkbox {
  width: 48%;
}
.checkbox_btn {
  width: 100%;
  transition: 0.2s all ease-in-out;
  font-size: 20px;
  display: flex;
  align-items: center;
  border: 2px solid rgba(120, 231, 120, 0.11);
  margin-top: 20px;
  border-radius: 5px;
  padding: 20px;
  cursor: pointer;
}
.checkbox_btn.active {
  border: 2px solid #00955f;
  background-color: #00955f;
}
.checkbox_btn.active b,
.checkbox_btn.active span {
  color: white;
}
.checkbox_btn b {
  transition: 0.2s all ease-in-out;
  font-weight: 700;
  font-size: 25px;
  color: #00955f;
  margin-right: 20px;
}
.checkbox_btn span {
  transition: 0.2s all ease-in-out;
  font-weight: 500;
  font-size: 18px;
}

.ant-steps-item-finish .ant-steps-item-icon {
  background: #00955f;
  border-color: #00955f;
}

.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
  color: white;
}
.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon_content {
  width: 80%;
}
.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon_wrap {
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px;
  gap: 10px;
}

.finish-test {
  padding: 50px 0;
  text-align: center;
}
.finish-test svg {
  display: block;
  margin: 0 auto 40px;
}
.finish-test h1 {
  font-weight: 700;
  font-size: 36px;
  line-height: 42px;
  text-align: center;
  color: #6b6b6b;
  margin-bottom: 35px;
}
.finish-test h2 {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #6b6b6b;
  margin-bottom: 30px;
}
.finish-test p {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  max-width: 310px;
  margin: 0 auto 30px;
}
.finish-test button {
  margin: 0 auto;
  display: block;
}

.test_wrapepr {
  width: 100%;
  margin: 0px auto;
}
@media screen and (max-width: 700px) {
  .test_wrapepr .wrapper_for_blocks {
    padding: 0 0 15px 0;
  }
}
@media screen and (max-width: 700px) {
  .test_wrapepr .test_footer button {
    margin-right: 10px;
  }
}

.modal-test .ant-modal-body {
  padding: 0;
  border-radius: 10px;
}

.verification {
  border-radius: 10px;
  background: #fff;
  background: var(--white, #fff);
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.15);
  padding: 24px 32px;
}
.verification p a {
  color: #00955f;
}
.verification h2 {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #6b6b6b;
  margin-bottom: 20px;
}
.verification h3 {
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #6b6b6b;
  margin-bottom: 15px;
}
.verification_steps {
  margin-top: 25px;
}
.verification_steps .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
  background-color: #ffa500 !important;
  border-color: #ffa500 !important;
}
.verification_steps .ant-steps-item-description {
  max-width: 90px !important;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #aeaeae;
}
.verification_step {
  display: flex;
  flex-wrap: wrap;
  margin-top: 50px;
}
.verification_nav {
  display: flex;
  margin-top: 20px;
}
.verification_nav button {
  margin-right: 25px;
}
.verification_completed {
  padding: 50px;
  text-align: center;
}
.verification_completed h1 {
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: #6b6b6b;
  margin-bottom: 15px;
}
.verification_completed h3 {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #6b6b6b;
}
.verification_completed img {
  margin: 35px 0;
}
.verification .w8 {
  margin-top: 25px;
}
.verification .w8 button {
  margin-right: 15px;
}

.w8-message {
  max-height: 200px;
  text-align: center;
}
.w8-message h1 {
  font-size: 23px;
  margin-bottom: 0;
  margin-top: 20px;
}
@media screen and (max-width: 1000px) {
  .w8-message h1 {
    font-size: 18px;
  }
}

.decline {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 20;
  background-color: rgba(136, 135, 135, 0.548);
  display: flex;
  align-items: center;
  justify-content: center;
}
.decline .ant-collapse {
  max-width: 70%;
  margin: 0 auto 20px;
}
.decline_content {
  width: 65%;
  height: auto;
  background-color: white;
  border-radius: 20px;
  box-shadow: 0px 10px 50px -15px rgba(132, 132, 132, 0.3);
  padding: 100px 25px;
  text-align: center;
}
.decline_content h1 {
  font-weight: 700;
  font-size: 32px;
  line-height: 38px;
  color: #6b6b6b;
}
.decline_content_img {
  margin: 90px 0;
}
.decline_content h6 {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #6b6b6b;
  max-width: 480px;
  margin: 0 auto;
  margin-bottom: 20px;
}

.privacy {
  padding-bottom: 15px;
}
.privacy small {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #aeaeae;
  margin-bottom: 45px;
  display: block;
}
.privacy h1 {
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;
  color: #000000;
}
.privacy b.link {
  color: #00955f;
}
.privacy b.doc {
  background-color: yellow;
}
.privacy h2 {
  margin-top: 30px;
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;
  color: #000000;
}

.withdrawal_table .email {
  color: #00955f;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
}
.withdrawal_table .ant-table {
  background: none !important;
}
.withdrawal_table .ant-table-thead {
  background-color: transparent;
}
.withdrawal_table .ant-table-thead .ant-table-cell {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #aeaeae;
}
.withdrawal_table .ant-table-thead > tr > th {
  background-color: transparent !important;
  border-bottom: none;
}
.withdrawal_table .ant-table-tbody .ant-table-cell {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #6b6b6b;
  border-bottom: 1px solid #aeaeae;
  padding-top: 10px;
  padding-bottom: 10px;
}
.withdrawal_table .ant-table-tbody .ant-table-cell .username {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
}

.document_information {
  padding: 35px 45px 0;
}
.document_information h1 {
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  color: #6b6b6b;
  margin-bottom: 40px;
}
.document_information .ant-timeline-item-content {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #6b6b6b;
}
.document_information .ant-timeline-item-tail {
  border-left: 1px dashed #00955f;
}

.files_wrap {
  display: flex;
}
.files_wrap .ant-upload-picture-card-wrapper {
  width: auto;
}

.overview {
  text-align: center;
}
.overview_empty {
  margin: 0 auto;
  text-align: center;
}
.overview_empty svg {
  margin-bottom: 40px;
}
.overview_empty_title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 15px;
  display: block;
  color: #6b6b6b;
}
.overview_empty_description {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 30px;
  display: block;
  color: #6b6b6b;
}
.overview_title {
  display: block;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #6b6b6b;
  margin-bottom: 40px;
}
.overview button {
  margin: 0 auto;
}
.overview_note {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #aeaeae;
  margin-top: 25px;
  display: block;
}
.overview_projects {
  margin-bottom: -40px;
}
@media screen and (max-width: 768px) {
  .overview_projects {
    margin-bottom: 0px;
  }
}
.overview_projects h6 {
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: #6b6b6b;
  margin-bottom: 40px;
}
.overview_projects_wrap {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 35px;
}
.overview_projects_wrap_top {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
}
.overview_projects .flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}
.overview_projects_item {
  background: #ffffff;
  box-shadow: 0px 10px 50px -15px rgba(132, 132, 132, 0.5);
  border-radius: 5px;
  padding: 25px 30px;
  width: 48%;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media screen and (max-width: 1024px) {
  .overview_projects_item {
    width: 100%;
    padding: 5px 20px;
  }
}
@media screen and (max-width: 768px) {
  .overview_projects_item {
    padding: 5px;
  }
}
@media screen and (max-width: 768px) {
  .overview_projects_item {
    padding-bottom: 15px;
  }
}
.overview_projects_item h5 {
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: #6b6b6b;
  margin-bottom: 20px;
}
.overview_projects_item img {
  max-width: 140px;
  max-height: 80px;
  border-radius: 2px;
  width: 33%;
  margin-bottom: 5px;
}
@media screen and (max-width: 1024px) {
  .overview_projects_item img {
    max-width: 100%;
    width: 100%;
    object-fit: cover;
    margin-bottom: 10px;
  }
}
.overview_projects_item_info {
  margin-left: 15px;
  width: calc(67% - 15px);
}
@media screen and (max-width: 1024px) {
  .overview_projects_item_info {
    width: 100%;
    margin-left: 0;
  }
}
.overview_projects_item_info b {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #6b6b6b;
  width: 45%;
}
@media screen and (max-width: 768px) {
  .overview_projects_item_info b {
    font-size: 14px;
  }
}
@media screen and (max-width: 1024px) {
  .overview_projects_item_info b {
    width: 36%;
  }
}
.overview_projects_item_info span {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #898989;
  width: 55%;
}
@media screen and (max-width: 768px) {
  .overview_projects_item_info span {
    font-size: 14px;
  }
}
@media screen and (max-width: 1024px) {
  .overview_projects_item_info span {
    width: 70%;
  }
}
.overview_projects_content {
  max-width: 100%;
}
.overview_projects_content_item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}
.overview_projects_content_item:last-child {
  margin-bottom: 0;
  opacity: 0.4;
}
.overview_projects_content_item:last-child b {
  font-size: 12px;
  font-weight: 500;
}
.overview_projects_content_item:last-child span {
  font-size: 12px;
  font-weight: 400;
}
.overview_projects_content b {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #6b6b6b;
  width: 33%;
}
.overview_projects_content span {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #898989;
  width: 66%;
  display: flex;
  align-items: center;
}
.overview_projects_content span svg {
  margin-left: 10px;
}
.overview_projects button {
  margin: 0 auto;
}

.our {
  max-width: calc(50% - 9px) !important;
}
@media screen and (max-width: 1024px) {
  .our {
    max-width: 100% !important;
  }
}

@media screen and (max-width: 689px) {
  .faq {
    padding-bottom: 50px;
  }
}
.faq_top {
  border-radius: 10px;
  background: #d0ece4;
  box-shadow: 0px 5px 20px 0px rgba(12, 64, 49, 0.15);
  padding: 45px 0;
  text-align: center;
  margin-bottom: 50px;
  width: 100%;
}
@media screen and (max-width: 830px) {
  .faq_top {
    padding: 15px 0;
  }
}
.faq_top h2 {
  font-size: 28px;
  font-weight: 500;
  color: #6b6b6b;
  margin-bottom: 35px;
}
@media screen and (max-width: 830px) {
  .faq_top h2 {
    font-size: 22px;
    margin-bottom: 15px;
  }
}
.faq_top .ant-input-affix-wrapper {
  max-width: 750px;
  border-radius: 20px;
}
@media screen and (max-width: 830px) {
  .faq_top .ant-input-affix-wrapper {
    max-width: 90%;
  }
}
.faq_footer {
  text-align: center;
  max-width: 440px;
  margin: 0 auto;
}
.faq_footer button {
  margin: 0 auto;
}
.faq_footer h3 {
  font-size: 28px;
  font-weight: 500;
  color: #aeaeae;
  margin-bottom: 15px;
}
@media screen and (max-width: 830px) {
  .faq_footer h3 {
    font-size: 21px;
  }
}
.faq_footer p {
  font-size: 16px;
  color: #aeaeae;
  margin: 0px 0 30px;
}
@media screen and (max-width: 830px) {
  .faq_footer p {
    font-size: 14px;
  }
}
.faq_content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 100px;
}
@media screen and (max-width: 830px) {
  .faq_content {
    margin-bottom: 50px;
  }
}
.faq_content_nav {
  max-width: 270px;
  width: 100%;
  padding: 32px 24px;
  background: #ffffff;
  box-shadow: 0px 10px 50px -15px rgba(132, 132, 132, 0.3);
  border-radius: 20px;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
}
@media screen and (max-width: 689px) {
  .faq_content_nav {
    margin: 0 auto 20px;
  }
}
.faq_content_nav ul {
  padding: 0;
  margin-bottom: 0;
}
.faq_content_nav li {
  list-style-type: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: #6b6b6b;
  margin-bottom: 30px;
  cursor: pointer;
  transition: 0.2 all cubic-bezier(0.075, 0.82, 0.165, 1);
  position: relative;
}
.faq_content_nav li:hover {
  opacity: 0.5;
  transition: 0.2 all cubic-bezier(0.075, 0.82, 0.165, 1);
}
.faq_content_nav li.active {
  color: #00955f;
  font-weight: 400;
}
.faq_content_nav li.active:before {
  content: "";
  position: absolute;
  left: -24px;
  top: 0;
  bottom: 0;
  width: 6px;
  background: #00955f;
  border-radius: 0px 2px 2px 0px;
}
.faq_content_nav li:last-of-type {
  margin-bottom: 0;
}
.faq_content_main {
  width: calc(100% - 300px);
}
@media screen and (max-width: 689px) {
  .faq_content_main {
    width: 100%;
  }
}
.faq_content_main .ant-collapse {
  border: none;
}
.faq_content_main .ant-collapse-item {
  border: none;
  margin-bottom: 15px;
}
.faq_content_main .ant-collapse-header {
  padding: 30px 40px !important;
  background: #ffffff;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.15);
  border-radius: 10px !important;
  font-weight: 400;
  font-size: 16px;
  color: #6b6b6b;
}
.faq_content_main .ant-collapse-header p {
  margin-bottom: 0;
  padding-right: 21px;
}
@media screen and (max-width: 830px) {
  .faq_content_main .ant-collapse-header {
    padding: 16px 20px !important;
  }
}
.faq_content_main .anticon {
  background: #d0ece4;
  color: #00955f;
  padding: 10px;
  border-radius: 100px;
  position: absolute;
  right: 16px;
}
@media screen and (max-width: 576px) {
  .faq_content_main .anticon {
    right: 0;
  }
}
.faq_content_main .ant-collapse-content {
  border: none;
  border-radius: 20px !important;
  padding-top: 10px;
}
.faq_content_main .ant-collapse-content p {
  margin-bottom: 0;
}
.faq_content_main .ant-collapse-content-box {
  padding: 30px 40px !important;
  border: none;
  box-shadow: 0px 10px 50px -15px rgba(132, 132, 132, 0.3);
}
.faq_content_main .ant-collapse-content-box p {
  font-weight: 400;
  font-size: 16px;
  color: #6b6b6b;
}
@media screen and (max-width: 830px) {
  .faq_content_main .ant-collapse-content-box {
    padding: 16px 20px !important;
  }
  .faq_content_main .ant-collapse-content-box p {
    font-size: 15px;
  }
}
.faq_empty {
  text-align: center;
  max-width: 340px;
  margin: 20px auto;
}
.faq_empty h2 {
  margin: 32px 0 16px;
}
.faq_empty p {
  color: #6b6b6b;
  font-size: 16px;
  margin-bottom: 0;
}

.highlight {
  color: #ffb12b;
  font-weight: 400;
  font-size: 16px;
}

.unenroll {
  margin-bottom: 27px;
}

.project_active {
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}
.project_active button {
  border: 1px solid #f00 !important;
  color: #f00 !important;
}
.project_active h1 {
  font-size: 32px;
  font-style: normal;
  font-weight: 500;
  color: #6b6b6b;
  margin-bottom: 0;
  margin-right: 30px;
}
@media screen and (max-width: 1024px) {
  .project_active h1 {
    font-size: 22px;
  }
}

.verification_center h1 {
  color: #6b6b6b;
  font-size: 32px;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 38px;
}
@media screen and (max-width: 1024px) {
  .verification_center h1 {
    font-size: 22px;
  }
}

.fee {
  margin: 20px auto 20px;
  text-align: center;
}
.fee p {
  font-size: 16px;
  font-weight: 400;
}
.fee b {
  color: #00955f;
  font-weight: 700;
}

.add-routing {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  width: 25px;
  margin-left: 15px;
  border: 2px solid #00955f;
  color: #00955f;
  border-radius: 100%;
  cursor: pointer;
  font-weight: 500;
  font-size: 21px;
}`, "",{"version":3,"sources":["webpack://./src/styles/pages.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAWI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCVU;EDWV,mBAAA;AANR;AASI;EACI,gBAAA;AAPR;AASQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCrBM;ADclB;;AAYA;EACI,aAAA;EACA,uBAAA;EACA,wDC5BK;ED6BL,kBAAA;AATJ;;AAWA;EACI,iBAAA;EACA,YAAA;EACA,WAAA;AARJ;AAUI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gDAAA;AARR;AAWI;EAZJ;IAaQ,iBAAA;EARN;AACF;AAWI;EAjBJ;IAkBQ,gBAAA;EARN;AACF;;AAUA;EACI,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gDAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;AAPJ;AASI;EACI,yBAAA;AAPR;AAUI;EAnBJ;IAoBQ,kBAAA;IACA,iBAAA;IACA,mBAAA;EAPN;AACF;AASI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,OAAA;EACA,UAAA;AAPR;AASQ;EACI,gBAAA;AAPZ;AAWI;EACI,YAAA;AATR;AAYI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCnGU;EDoGV,0BAAA;AAVR;AAaI;EACI,kBAAA;EACA,cAAA;AAXR;AAaQ;EAJJ;IAKQ,kBAAA;EAVV;AACF;AAYQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cCpHA;EDqHA,kBAAA;AAVZ;AAYY;EAPJ;IAQQ,gBAAA;IACA,eAAA;IACA,iBAAA;EATd;AACF;AAYQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCjIM;EDkIN,2BAAA;EACA,iBAAA;AAVZ;AAYY;EARJ;IASQ,eAAA;IACA,iBAAA;EATd;AACF;AAaI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;AAXR;AAaQ;EAPJ;IAQQ,sBAAA;IACA,2BAAA;IACA,mBAAA;EAVV;AACF;AAYQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC7JM;ED8JN,gBAAA;AAVZ;AAYY;EAPJ;IAQQ,kBAAA;EATd;AACF;AAYQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC1KA;ED2KA,oBAAA;AAVZ;AAYY;EACI,YAAA;EACA,oBAAA;AAVhB;;AAgBA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAbJ;;AAgBA;EACI,6BAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;AAbJ;AAeI;EACI,8BAAA;AAbR;AAgBI;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;AAdR;AAgBQ;EACI,cC9MA;ED+MA,gBAAA;AAdZ;AAeY;EACI,eAAA;AAbhB;AAiBQ;EACI,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAfZ;AAkBQ;EACI,eAAA;EACA,gBAAA;AAhBZ;AAoBI;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAlBR;AAqBI;EACI,kBAAA;AAnBR;AAsBI;EACI,aAAA;EACA,mBAAA;AApBR;AAsBQ;EACI,kBAAA;AApBZ;AAuBQ;EACI,eAAA;AArBZ;AAyBI;EACI,eAAA;EACA,iBAAA;EACA,cC7PU;ADsOlB;AAyBQ;EACI,kBAAA;AAvBZ;AA0BQ;EATJ;IAUQ,eAAA;EAvBV;AACF;AA0BI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC5QU;ADoPlB;AA0BQ;EANJ;IAOQ,eAAA;EAvBV;AACF;AA2BQ;EACI,cCtRA;EDuRA,gBAAA;AAzBZ;AA0BY;EACI,eAAA;AAxBhB;;AAiCY;EADJ;IAEQ,2BAAA;EA7Bd;AACF;AAkCQ;EACI,WAAA;EACA,kBAAA;AAhCZ;AAoCI;EACI,mBAAA;AAlCR;AAoCQ;EAHJ;IAIQ,cAAA;EAjCV;AACF;AAoCI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AAlCR;AAqCI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCjUU;EDkUV,mBAAA;AAnCR;AAsCI;EACI,wDAAA;EACA,YAAA;EACA,mBAAA;AApCR;AAsCQ;EALJ;IAMQ,kBAAA;EAnCV;AACF;AAqCQ;EACI,YAAA;AAnCZ;AAuCI;EACI,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;AArCR;AAwCI;EACI,wCAAA;AAtCR;AAyCI;EACI,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;AAvCR;AAyCQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCxWM;ADiUlB;AAyCQ;EACI,sBAAA;AAvCZ;AAyCQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCjXM;AD0UlB;AA2CI;EACI,gBAAA;AAzCR;AA0CQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAxCZ;AA0CQ;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;AAxCZ;AA2CQ;EACI,aAAA;EACA,8BAAA;AAzCZ;AA2CY;EACI,qBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;AAzChB;AA6CQ;EACI,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA3CZ;AA+CI;EACI,cAAA;EACA,eAAA;AA7CR;AAgDI;EACI,aAAA;EACA,sBAAA;AA9CR;AAgDQ;EACI,iBAAA;EACA,eAAA;AA9CZ;AAiDQ;EACI,kBAAA;AA/CZ;AAmDI;EACI,kBAAA;AAjDR;AAmDI;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAjDR;AAoDI;EACI,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;AAlDR;AAoDQ;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,mDAAA;EACA,cAAA;EACA,oBAAA;EACA,mDAAA;AAlDZ;AAoDY;EACI,cCpdJ;EDqdI,uBAAA;EACA,oBAAA;AAlDhB;;AAwDA;EACI,aAAA;EACA,8BAAA;AArDJ;AAuDI;EACI,qBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AArDR;;AAyDA;EACI,kBAAA;AAtDJ;AAwDI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC/eU;EDgfV,mBAAA;EACA,kBAAA;AAtDR;AAyDI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;AAvDR;AAyDQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC7fM;ED8fN,eAAA;EACA,gBAAA;AAvDZ;AA0DQ;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCvgBM;EDwgBN,gBAAA;AAxDZ;AA4DI;EACI,UAAA;EACA,gBAAA;AA1DR;;AA8DA;EACI,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AA3DJ;AA6DI;EACI,uBAAA;AA3DR;AA8DI;EACI,eAAA;EACA,mBAAA;AA5DR;AA8DQ;EACI,wBAAA;AA5DZ;AAgEI;EACI,eAAA;EACA,mBAAA;AA9DR;AAiEI;EACI,iBAAA;EACA,8BAAA;EACA,gBAAA;AA/DR;;AAmEA;EACI,mBAAA;EACA,kBAAA;AAhEJ;AAkEI;EACI,eAAA;EACA,gBAAA;AAhER;AAmEI;EACI,YAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AAjER;;AAoEA;EACI,eAAA;EACA,iBAAA;EACA,cAAA;AAjEJ;;AAmEA;EACI,cCzkBQ;ADygBZ;;AAmEI;EA7kBA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCDc;EDEd,mBAAA;AA8gBJ;AA+DI;EACI,gBAAA;EACA,iBAAA;AA7DR;AAgEI;EACI,aAAA;EACA,mBAAA;AA9DR;AAgEQ;EACI,kBAAA;AA9DZ;AAiEQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cChmBM;EDimBN,mBAAA;AA/DZ;AAiEQ;EACI,eAAA;EACA,iBAAA;EACA,cCtmBM;ADuiBlB;;AAoEI;EA7mBA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCDc;EDEd,mBAAA;AA6iBJ;AA+DQ;EAHJ;IAIQ,eAAA;EA5DV;AACF;AA+DI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AA7DR;AA+DQ;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AA7DZ;AA+DY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AA7DhB;AA+DgB;EACI,WAAA;EACA,YAAA;AA7DpB;AAiEY;EACI,eAAA;EACA,gBAAA;AA/DhB;AAoEQ;EACI,eAAA;EACA,kBAAA;AAlEZ;AAoEQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCvpBM;EDwpBN,kBAAA;EACA,gBAAA;AAlEZ;AAoEY;EARJ;IASQ,eAAA;EAjEd;AACF;AAmEQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCnqBM;EDoqBN,kBAAA;EACA,gBAAA;AAjEZ;AAmEY;EARJ;IASQ,eAAA;EAhEd;AACF;;AAoEA;EACI,kBAAA;AAjEJ;AAmEI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AAjER;AAoEI;EACI,eAAA;EACA,gBAAA;AAlER;AAqEI;EACI,eAAA;AAnER;AAsEI;EACI,cAAA;EACA,mBAAA;AApER;;AAyEQ;EADJ;IAEQ,kBAAA;EArEV;AACF;;AAyEI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AAtER;AAwEI;EACI,eAAA;EACA,gBAAA;AAtER;AAyEI;EACI,WAAA;EACA,gBAAA;AAvER;AA0EI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,4CAAA;AAxER;AA0EQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AAxEZ;AA2EQ;EACI,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAzEZ;AA2EY;EACI,eAAA;AAzEhB;AA+EI;EACI,gBAAA;EACA,kBAAA;EACA,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EAEA,gCAAA;AA9ER;AAgFQ;EACI,gCAAA;EACA,2CAAA;AA9EZ;AAiFQ;EACI,eAAA;EACA,SAAA;EACA,gBAAA;EACA,cC1wBA;ED2wBA,cAAA;EACA,aAAA;EACA,mBAAA;AA/EZ;AAiFY;EACI,eAAA;EACA,iBAAA;AA/EhB;;AAoFA;EACI,kBAAA;EACA,uBAAA;EACA,gBAAA;AAjFJ;AAkFI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AAhFR;AAkFI;EACI,eAAA;EACA,gBAAA;AAhFR;;AAoFA;EACI,aAAA;EACA,eAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;AAjFJ;AAmFI;EACI,aAAA;EACA,oBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAjFR;AAmFQ;EACI,UAAA;AAjFZ;AAmFY;EAHJ;IAIQ,WAAA;IACA,mBAAA;EAhFd;AACF;AAoFI;EACI,UAAA;EACA,kDAAA;AAlFR;AAoFQ;EAJJ;IAKQ,aAAA;EAjFV;AACF;AAmFQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cCz0BM;ADwvBlB;AAmFY;EACI,cC70BJ;AD4vBZ;AAsFI;EACI,UAAA;AApFR;AAsFQ;EAHJ;IAIQ,WAAA;EAnFV;AACF;AAsFI;EACI,aAAA;EACA,eAAA;EACA,eAAA;EACA,SAAA;AApFR;;AAuFA;EACI,mBAAA;EACA,8BAAA;EACA,eAAA;AApFJ;AAsFI;EALJ;IAMQ,UAAA;EAnFN;AACF;AAqFI;EATJ;IAUQ,WAAA;EAlFN;AACF;AAqFQ;EACI,cCh3BA;EDi3BA,kCAAA;AAnFZ;AAuFI;EACI,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,kCAAA;AArFR;AAuFQ;EANJ;IAOQ,eAAA;EApFV;AACF;AAuFI;EACI,aAAA;EACA,WAAA;EACA,mBAAA;AArFR;AAuFQ;EALJ;IAMQ,aAAA;EApFV;AACF;AAqFQ;EARJ;IASQ,aAAA;IACA,iBAAA;EAlFV;AACF;;AAqFA;EACI,eAAA;AAlFJ;AAoFI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAlFR;AAqFI;EACI,eAAA;EACA,WAAA;EACA,gBAAA;AAnFR;AAqFQ;EALJ;IAMQ,eAAA;IACA,WAAA;IACA,mBAAA;EAlFV;AACF;AAsFQ;EADJ;IAEQ,mBAAA;EAnFV;AACF;AAuFQ;EADJ;IAEQ,wBAAA;EApFV;AACF;AAwFQ;EADJ;IAEQ,wBAAA;EArFV;AACF;AAwFI;EACI,aAAA;EACA,mBAAA;AAtFR;AAuFQ;EACI,iBAAA;AArFZ;;AAyFA;EACI,iBAAA;AAtFJ;AAwFI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,yBCr8BI;EDs8BJ,4BAAA;AAtFR;AAwFQ;EARJ;IASQ,YAAA;EArFV;AACF;AAuFQ;EACI,YAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AArFZ;AAuFY;EARJ;IASQ,eAAA;EApFd;AACF;AAyFQ;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAvFZ;AAyFY;EANJ;IAOQ,eAAA;EAtFd;AACF;AAwFQ;EACI,aAAA;EACA,eAAA;EACA,8BAAA;AAtFZ;AAyFgB;EADJ;IAEQ,eAAA;EAtFlB;AACF;AA0FQ;EACI,WAAA;EAEA,iBAAA;AAzFZ;AA6FI;EACI,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AA3FR;AA6FQ;EACI,UAAA;AA3FZ;;AAgGA;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;AA7FJ;;AAgGA;EACI,UAAA;AA7FJ;AA+FI;EACI,WAAA;EACA,gCAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AA7FR;AA+FQ;EACI,yBAAA;EACA,yBC5hCA;AD+7BZ;AA+FY;;EAEI,YAAA;AA7FhB;AAiGQ;EACI,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cCxiCA;EDyiCA,kBAAA;AA/FZ;AAkGQ;EACI,gCAAA;EACA,gBAAA;EACA,eAAA;AAhGZ;;AAqGA;EACI,mBCrjCQ;EDsjCR,qBCtjCQ;ADo9BZ;;AAoGA;EACI,YAAA;AAjGJ;AAkGI;EACI,UAAA;AAhGR;AAmGI;EACI,aAAA;EACA,eAAA;EACA,eAAA;EACA,SAAA;AAjGR;;AAoGA;EACI,eAAA;EACA,kBAAA;AAjGJ;AAmGI;EACI,cAAA;EACA,mBAAA;AAjGR;AAmGI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cCjlCU;EDklCV,mBAAA;AAjGR;AAoGI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cC1lCU;ED2lCV,mBAAA;AAlGR;AAqGI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAnGR;AAsGI;EACI,cAAA;EACA,cAAA;AApGR;;AAuGA;EACI,WAAA;EACA,gBAAA;AApGJ;AAuGQ;EADJ;IAEQ,mBAAA;EApGV;AACF;AAyGY;EADJ;IAEQ,kBAAA;EAtGd;AACF;;AA2GI;EACI,UAAA;EACA,mBAAA;AAxGR;;AA4GA;EACI,mBAAA;EACA,gBAAA;EAAA,8BAAA;EACA,gDAAA;EACA,kBAAA;AAzGJ;AA2GI;EACI,cC7oCI;ADoiCZ;AA4GI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCnpCU;EDopCV,mBAAA;AA1GR;AA6GI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC3pCU;ED4pCV,mBAAA;AA3GR;AA8GI;EACI,gBAAA;AA5GR;AA6GQ;EACI,oCAAA;EACA,gCAAA;AA3GZ;AA8GQ;EACI,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA5GZ;AAgHI;EACI,aAAA;EACA,eAAA;EACA,gBAAA;AA9GR;AAiHI;EACI,aAAA;EACA,gBAAA;AA/GR;AAiHQ;EACI,kBAAA;AA/GZ;AAmHI;EACI,aAAA;EACA,kBAAA;AAjHR;AAmHQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCtsCM;EDusCN,mBAAA;AAjHZ;AAoHQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC9sCM;AD4lClB;AAqHQ;EACI,cAAA;AAnHZ;AAuHI;EACI,gBAAA;AArHR;AAuHQ;EACI,kBAAA;AArHZ;;AAyHA;EACI,iBAAA;EACA,kBAAA;AAtHJ;AAwHI;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AAtHR;AAwHQ;EALJ;IAMQ,eAAA;EArHV;AACF;;AAwHA;EACI,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EAEA,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAtHJ;AAwHI;EACI,cAAA;EACA,mBAAA;AAtHR;AAyHI;EACI,UAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,wDClwCC;EDmwCD,mBAAA;EACA,kBAAA;AAvHR;AAyHQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC3wCM;ADopClB;AA0HQ;EACI,cAAA;AAxHZ;AA2HQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCtxCM;EDuxCN,gBAAA;EACA,cAAA;EACA,mBAAA;AAzHZ;;AA6HA;EACI,oBAAA;AA1HJ;AA2HI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;AAzHR;AA4HI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA1HR;AA8HQ;EACI,cClzCA;ADsrCZ;AA+HQ;EACI,wBAAA;AA7HZ;AAiII;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA/HR;;AAqIQ;EACI,cCt0CA;EDu0CA,gBAAA;EACA,eAAA;EACA,iBAAA;AAlIZ;AAqIQ;EACI,2BAAA;AAnIZ;AAqIQ;EACI,6BAAA;AAnIZ;AAqIY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAnIhB;AAsIQ;EACI,wCAAA;EACA,mBAAA;AApIZ;AAwIY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCl2CE;EDm2CF,gCAAA;EACA,iBAAA;EACA,oBAAA;AAtIhB;AAwIgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AAtIpB;;AA4IA;EACI,oBAAA;AAzIJ;AA2II;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCv3CU;EDw3CV,mBAAA;AAzIR;AA4II;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC/3CU;ADqvClB;AA6II;EACI,+BAAA;AA3IR;;AA8IA;EACI,aAAA;AA3IJ;AA6II;EACI,WAAA;AA3IR;;AA+IA;EACI,kBAAA;AA5IJ;AA8II;EACI,cAAA;EACA,kBAAA;AA5IR;AA8IQ;EACI,mBAAA;AA5IZ;AA+IQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AA7IZ;AA+IQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AA7IZ;AAuJI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCp7CU;EDq7CV,mBAAA;AArJR;AAwJI;EACI,cAAA;AAtJR;AAyJI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AAvJR;AA0JI;EACI,oBAAA;AAxJR;AA0JQ;EAHJ;IAIQ,kBAAA;EAvJV;AACF;AAyJQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCj9CM;EDk9CN,mBAAA;AAvJZ;AA0JQ;EACI,aAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;AAxJZ;AA2JQ;EACI,aAAA;EACA,8BAAA;EACA,eAAA;EACA,WAAA;AAzJZ;AA4JQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AA1JZ;AA6JQ;EACI,mBAAA;EACA,wDAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AA3JZ;AA6JY;EAXJ;IAYQ,WAAA;IACA,iBAAA;EA1Jd;AACF;AA4JY;EAhBJ;IAiBQ,YAAA;EAzJd;AACF;AA2JY;EApBJ;IAqBQ,oBAAA;EAxJd;AACF;AA0JY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCtgDE;EDugDF,mBAAA;AAxJhB;AA2JY;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AAzJhB;AA2JgB;EAPJ;IAQQ,eAAA;IACA,WAAA;IACA,iBAAA;IACA,mBAAA;EAxJlB;AACF;AA2JY;EACI,iBAAA;EACA,uBAAA;AAzJhB;AA2JgB;EAJJ;IAKQ,WAAA;IACA,cAAA;EAxJlB;AACF;AA0JgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCtiDF;EDuiDE,UAAA;AAxJpB;AA0JoB;EAPJ;IAQQ,eAAA;EAvJtB;AACF;AAyJoB;EAXJ;IAYQ,UAAA;EAtJtB;AACF;AAyJgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAvJpB;AAyJoB;EAPJ;IAQQ,eAAA;EAtJtB;AACF;AAwJoB;EAXJ;IAYQ,UAAA;EArJtB;AACF;AA0JQ;EAEI,eAAA;AAzJZ;AA2JY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAzJhB;AA2JY;EACI,gBAAA;EACA,YAAA;AAzJhB;AA2JgB;EACI,eAAA;EACA,gBAAA;AAzJpB;AA2JgB;EACI,eAAA;EACA,gBAAA;AAzJpB;AA4JY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC9lDE;ED+lDF,UAAA;AA1JhB;AA6JY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AA3JhB;AA6JgB;EACI,iBAAA;AA3JpB;AAgKQ;EACI,cAAA;AA9JZ;;AAmKA;EACI,qCAAA;AAhKJ;AAkKI;EAHJ;IAIQ,0BAAA;EA/JN;AACF;;AAmKI;EADJ;IAEQ,oBAAA;EA/JN;AACF;AAiKI;EACI,mBAAA;EACA,mBAAA;EACA,mDAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AA/JR;AAiKQ;EATJ;IAUQ,eAAA;EA9JV;AACF;AAgKQ;EACI,eAAA;EACA,gBAAA;EACA,cCppDM;EDqpDN,mBAAA;AA9JZ;AAgKY;EANJ;IAOQ,eAAA;IACA,mBAAA;EA7Jd;AACF;AA+JQ;EACI,gBAAA;EACA,mBAAA;AA7JZ;AA+JY;EAJJ;IAKQ,cAAA;EA5Jd;AACF;AA+JI;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;AA7JR;AA+JQ;EACI,cAAA;AA7JZ;AAgKQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA9JZ;AAgKY;EANJ;IAOQ,eAAA;EA7Jd;AACF;AA+JQ;EACI,eAAA;EACA,cAAA;EACA,kBAAA;AA7JZ;AA+JY;EALJ;IAMQ,eAAA;EA5Jd;AACF;AA+JI;EACI,aAAA;EACA,8BAAA;EACA,eAAA;EACA,oBAAA;AA7JR;AA+JQ;EANJ;IAOQ,mBAAA;EA5JV;AACF;AA8JQ;EACI,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,wDAAA;EACA,mBAAA;EACA,2BAAA;EAAA,wBAAA;EAAA,mBAAA;AA5JZ;AA8JY;EATJ;IAUQ,mBAAA;EA3Jd;AACF;AA6JY;EACI,UAAA;EACA,gBAAA;AA3JhB;AA6JY;EACI,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCluDE;EDmuDF,mBAAA;EACA,eAAA;EACA,uDAAA;EACA,kBAAA;AA3JhB;AA4JgB;EACI,YAAA;EACA,uDAAA;AA1JpB;AA4JgB;EACI,cC7uDR;ED8uDQ,gBAAA;AA1JpB;AA4JoB;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,8BAAA;AA1JxB;AA8JgB;EACI,gBAAA;AA5JpB;AAgKQ;EACI,yBAAA;AA9JZ;AAgKY;EAHJ;IAIQ,WAAA;EA7Jd;AACF;AA+JY;EACI,YAAA;AA7JhB;AA+JY;EACI,YAAA;EACA,mBAAA;AA7JhB;AA+JY;EACI,6BAAA;EACA,mBAAA;EACA,gDAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,cCrxDE;ADwnDlB;AA+JgB;EACI,gBAAA;EACA,mBAAA;AA7JpB;AAgKgB;EAdJ;IAeQ,6BAAA;EA7JlB;AACF;AA+JY;EACI,mBAAA;EACA,cCnyDJ;EDoyDI,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;AA7JhB;AA+JgB;EARJ;IASQ,QAAA;EA5JlB;AACF;AA8JY;EACI,YAAA;EACA,8BAAA;EACA,iBAAA;AA5JhB;AA8JgB;EACI,gBAAA;AA5JpB;AA+JY;EACI,6BAAA;EACA,YAAA;EACA,wDAAA;AA7JhB;AA+JgB;EACI,gBAAA;EACA,eAAA;EACA,cC7zDF;ADgqDlB;AAgKgB;EAXJ;IAYQ,6BAAA;EA7JlB;EA+JkB;IACI,eAAA;EA7JtB;AACF;AAkKI;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;AAhKR;AAkKQ;EACI,mBAAA;AAhKZ;AAmKQ;EACI,cCp1DM;EDq1DN,eAAA;EACA,gBAAA;AAjKZ;;AAqKA;EACI,cAAA;EACA,gBAAA;EACA,eAAA;AAlKJ;;AAoKA;EACI,mBAAA;AAjKJ;;AAmKA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;AAhKJ;AAkKI;EACI,iCAAA;EACA,sBAAA;AAhKR;AAmKI;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cCh3DU;EDi3DV,gBAAA;EACA,kBAAA;AAjKR;AAmKQ;EARJ;IASQ,eAAA;EAhKV;AACF;;AAoKI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAjKR;AAmKQ;EAPJ;IAQQ,eAAA;EAhKV;AACF;;AAoKA;EACI,sBAAA;EACA,kBAAA;AAjKJ;AAmKI;EACE,eAAA;EACA,gBAAA;AAjKN;AAoKI;EACE,cCl5DM;EDm5DN,gBAAA;AAlKN;;AAsKE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,cC/5DQ;EDg6DR,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAnKJ","sourcesContent":["@import \"./variables.scss\";\n\n@mixin h1 {\n    font-weight: 600;\n    font-size: 24px;\n    line-height: 28px;\n    color: $font-color-grey;\n    margin-bottom: 25px;\n}\n\n.dashboard {\n    h1 {\n        font-weight: 700;\n        font-size: 32px;\n        line-height: 37px;\n        color: $font-color-grey;\n        margin-bottom: 25px;\n    }\n\n    &_jobs {\n        margin-top: 30px;\n\n        & h1 {\n            font-weight: 500;\n            font-size: 20px;\n            line-height: 21px;\n            color: $font-color-grey;\n        }\n    }\n}\n\n.tasks_list {\n    padding: 10px;\n    background-color: white;\n    box-shadow: $shadow;\n    border-radius: 5px;\n}\n.rws {\n    max-height: 260px;\n    height: 100%;\n    width: 100%;\n\n    video {\n        width: 100%;\n        height: 100%;\n        border-radius: 10px;\n        box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.15);\n    }\n\n    @media screen and (max-width: $desktop) {\n        max-height: 250px;\n        // margin-top: 29px;\n    }\n\n    @media screen and (max-width: 767px) {\n        margin-top: 15px;\n    }\n}\n.balance {\n    position: relative;\n    border-radius: 10px;\n    padding: 24px 32px;\n    box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.15);\n    background-image: url(\"../assets/card-background.jpg\");\n    background-repeat: no-repeat;\n    background-size: cover;\n    max-height: 260px;\n    height: 100%;\n    overflow: hidden;\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n\n    .ant-progress {\n        line-height: 0 !important;\n    }\n\n    @media screen and (max-width: $desktop) {\n        padding: 10px 20px;\n        max-height: 250px;\n        margin-bottom: 30px;\n    }\n\n    &_pending {\n        position: absolute;\n        font-size: 17px;\n        font-weight: 500;\n        color: #ffb12b;\n        left: 0;\n        top: -22px;\n\n        b {\n            font-weight: 800;\n        }\n    }\n\n    svg {\n        height: 31px;\n    }\n\n    &_currency {\n        font-weight: 500;\n        font-size: 20px;\n        line-height: 23px;\n        color: $font-color-grey;\n        text-transform: capitalize;\n    }\n\n    &_money {\n        position: relative;\n        margin: 30px 0;\n\n        @media screen and (max-width: $desktop) {\n            margin: 30px 0 5px;\n        }\n\n        h6 {\n            font-size: 48px;\n            font-weight: 500;\n            line-height: 56px;\n            color: $font-clor;\n            margin-bottom: 5px;\n\n            @media screen and (max-width: $desktop) {\n                font-weight: 500;\n                font-size: 25px;\n                line-height: 26px;\n            }\n        }\n\n        p {\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 16px;\n            color: $font-color-grey;\n            margin-bottom: 0 !important;\n            line-height: 16px;\n\n            @media screen and (max-width: $desktop) {\n                font-size: 16px;\n                line-height: 16px;\n            }\n        }\n    }\n\n    &_info {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        width: 100%;\n        margin-top: 5px;\n\n        @media screen and (max-width: $desktop) {\n            flex-direction: column;\n            justify-content: flex-start;\n            align-items: normal;\n        }\n\n        p {\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 19px;\n            color: $font-color-grey;\n            margin-bottom: 0;\n\n            @media screen and (max-width: $tablet) {\n                margin-bottom: 8px;\n            }\n        }\n\n        a {\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 19px;\n            color: $font-clor;\n            transition: 0.2s all;\n\n            &:hover {\n                opacity: 0.5;\n                transition: 0.2s all;\n            }\n        }\n    }\n}\n\n.statistic-dashboard {\n    width: 100%;\n    height: 100%;\n    margin-bottom: 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.task_item {\n    background-color: transparent;\n    margin-bottom: 15px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid rgba(182, 182, 182, 0.5);\n\n    &:last-of-type {\n        border-bottom: none !important;\n    }\n\n    &_mobile {\n        margin-bottom: 15px;\n        display: flex;\n        align-items: center;\n\n        .anticon:not(.anticon-star) {\n            color: $font-clor;\n            margin-left: 5px;\n            &:hover {\n                cursor: pointer;\n            }\n        }\n\n        &_key {\n            width: 120px;\n            font-size: 14px;\n            line-height: 16px;\n            color: #aeaeae;\n            font-weight: 400;\n        }\n\n        &_value {\n            font-size: 15px;\n            font-weight: 500;\n        }\n    }\n\n    &_description_nav {\n        margin: 30px 0;\n        font-size: 14px;\n        line-height: 16px;\n        color: #aeaeae;\n    }\n\n    img {\n        margin-right: 10px;\n    }\n\n    &_type {\n        display: flex;\n        align-items: center;\n\n        svg {\n            margin-right: 10px;\n        }\n\n        b {\n            font-size: 16px;\n        }\n    }\n\n    &_title {\n        font-size: 16px;\n        line-height: 19px;\n        color: $font-color-grey;\n\n        &.mobile {\n            margin-right: 10px;\n        }\n\n        @media screen and (max-width: $desktop) {\n            font-size: 14px;\n        }\n    }\n\n    & b {\n        font-weight: 700;\n        font-size: 16px;\n        line-height: 19px;\n        color: $font-color-grey;\n\n        @media screen and (max-width: $desktop) {\n            font-size: 14px;\n        }\n    }\n\n    &_reward {\n        .anticon {\n            color: $font-clor;\n            margin-left: 3px;\n            &:hover {\n                cursor: pointer;\n            }\n        }\n    }\n}\n\n.myMoney {\n    .ant-table-tbody {\n        .ant-table-cell {\n            @media screen and (max-width: $desktop) {\n                padding: 8px 4px !important;\n            }\n        }\n    }\n\n    .transaction_detail {\n        .ant-tag {\n            width: 80px;\n            text-align: center;\n        }\n    }\n\n    .balance {\n        margin-bottom: 20px;\n\n        @media screen and (max-width: $desktop) {\n            margin: 10px 0;\n        }\n    }\n\n    video {\n        width: 100%;\n        height: 100%;\n        border-radius: 20px;\n        margin-bottom: 20px;\n    }\n\n    h1 {\n        font-weight: 500;\n        font-size: 18px;\n        line-height: 21px;\n        color: $font-color-grey;\n        margin-bottom: 25px;\n    }\n\n    .wrapper_for_blocks {\n        box-shadow: 0px 10px 50px -15px rgba(132, 132, 132, 0.3);\n        height: auto;\n        margin-bottom: 15px;\n\n        @media screen and (max-width: $desktop) {\n            margin-bottom: 0px;\n        }\n\n        &_form {\n            height: 100%;\n        }\n    }\n\n    button {\n        margin: 0 auto;\n        text-align: center;\n        justify-content: center;\n        max-width: 60%;\n    }\n\n    .ant-table-thead > tr > th {\n        background-color: transparent !important;\n    }\n\n    &_success {\n        text-align: center;\n        max-width: 282px;\n        width: 100%;\n        margin: 20px auto 20px;\n\n        h2 {\n            font-weight: 500;\n            font-size: 18px;\n            line-height: 21px;\n            color: $font-color-grey;\n        }\n        img {\n            margin: 25px auto 25px;\n        }\n        p {\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 19px;\n            color: $font-color-grey;\n        }\n    }\n\n    &_code {\n        max-width: 382px;\n        &_wrap {\n            display: flex;\n            margin-bottom: 30px;\n            justify-content: center;\n        }\n        .code_input {\n            width: 36px;\n            height: 40px;\n            border: 1px solid #898989;\n            border-radius: 6px;\n            margin-right: 8px;\n            text-align: center;\n            padding: 0;\n            font-weight: 600;\n            font-size: 18px;\n        }\n\n        &_btn {\n            display: flex;\n            justify-content: space-between;\n\n            button {\n                width: 45% !important;\n                max-width: 100% !important;\n                padding-left: 0;\n                padding-right: 0;\n                height: 40px !important;\n                justify-content: center;\n            }\n        }\n\n        &_resend {\n            text-align: center;\n            display: inline-block;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 19px;\n            cursor: pointer;\n            color: #aeaeae;\n            margin-top: 30px;\n        }\n    }\n\n    .link {\n        color: #096dd9;\n        cursor: pointer;\n    }\n\n    .payout_declined {\n        display: flex;\n        flex-direction: column;\n\n        .ant-tag {\n            padding: 6px 15px;\n            font-size: 14px;\n        }\n\n        button {\n            margin: 20px 0 0 0;\n        }\n    }\n\n    .title {\n        margin-bottom: 5px;\n    }\n    .sub_title {\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        color: #aeaeae;\n        margin-bottom: 25px;\n    }\n\n    &_tab_title {\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n        margin-bottom: 25px;\n\n        &_item {\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 400;\n            cursor: pointer;\n            margin-right: 20px;\n            padding: 5px 30px;\n            background-color: #b6b6b680;\n            color: #aeaeae;\n            transition: all 0.3s;\n            border: 1px solid #b6b6b680;\n\n            &.active {\n                color: $font-clor;\n                background-color: white;\n                transition: all 0.3s;\n            }\n        }\n    }\n}\n\n.myMoney_code_btn {\n    display: flex;\n    justify-content: space-between;\n\n    button {\n        width: 45% !important;\n        max-width: 100% !important;\n        padding-left: 0;\n        padding-right: 0;\n        height: 40px !important;\n    }\n}\n\n.transaction_detail {\n    padding: 30px 45px;\n\n    h2 {\n        font-weight: 500;\n        font-size: 24px;\n        line-height: 28px;\n        color: $font-color-grey;\n        margin-bottom: 60px;\n        text-align: center;\n    }\n\n    &_item {\n        margin-bottom: 8px;\n        display: flex;\n        align-items: center;\n\n        p {\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 19px;\n            color: $font-color-grey;\n            min-width: 90px;\n            margin-bottom: 0;\n        }\n\n        b {\n            min-width: 90px;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 19px;\n            color: $font-color-grey;\n            margin-top: 50px;\n        }\n    }\n\n    button {\n        width: 50%;\n        margin-top: 30px;\n    }\n}\n\n.payment {\n    text-align: center;\n    margin-bottom: 20px;\n    background-color: white;\n    padding: 40px 20px;\n    border-radius: 10px;\n\n    .payment_confirm{\n        width: 450px !important;\n    }\n\n    h1 {\n        font-size: 40px;\n        margin-bottom: 10px;\n\n        b {\n            color: rgb(20, 123, 192);\n        }\n    }\n\n    h4 {\n        font-size: 16px;\n        margin-bottom: 10px;\n    }\n\n    &_btn {\n        flex-wrap: nowrap;\n        justify-content: space-between;\n        margin-top: 50px;\n    }\n}\n\n.errorboundary {\n    padding: 100px 50px;\n    text-align: center;\n\n    h1 {\n        font-size: 60px;\n        font-weight: 700;\n    }\n\n    img {\n        width: 500px;\n        height: 350px;\n        display: block;\n        margin: 20px auto;\n    }\n}\n.ant-tabs-tab {\n    font-size: 14px;\n    line-height: 16px;\n    color: #898989;\n}\n.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n    color: $font-clor;\n}\n.job_info {\n    h1 {\n        @include h1;\n    }\n\n    &_btn {\n        margin-top: 20px;\n        text-align: right;\n    }\n\n    &_job {\n        display: flex;\n        margin-bottom: 40px;\n\n        div {\n            margin-right: 40px;\n        }\n\n        h3 {\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 19px;\n            color: $font-color-grey;\n            margin-bottom: 10px;\n        }\n        p {\n            font-size: 16px;\n            line-height: 19px;\n            color: $font-color-grey;\n        }\n    }\n}\n.job_detail {\n    h1 {\n        @include h1;\n\n        @media screen and (max-width: $desktop) {\n            font-size: 20px;\n        }\n    }\n\n    &_item {\n        display: flex;\n        align-items: center;\n        margin-bottom: 15px;\n\n        &_price {\n            display: flex;\n            align-items: center;\n            margin-right: 15px;\n\n            &_icon {\n                width: 40px;\n                height: 40px;\n                margin-right: 7px;\n\n                svg {\n                    width: 40px;\n                    height: 40px;\n                }\n            }\n\n            &_price {\n                font-size: 16px;\n                font-weight: 700;\n            }\n        }\n\n        // span.anticon,\n        svg {\n            font-size: 14px;\n            margin-right: 10px;\n        }\n        p {\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 19px;\n            color: $font-color-grey;\n            margin-right: 15px;\n            margin-bottom: 0;\n\n            @media screen and (max-width: $desktop) {\n                font-size: 12px;\n            }\n        }\n        b {\n            font-weight: 600;\n            font-size: 16px;\n            line-height: 19px;\n            color: $font-color-grey;\n            margin-right: 15px;\n            margin-bottom: 0;\n\n            @media screen and (max-width: $desktop) {\n                font-size: 14px;\n            }\n        }\n    }\n}\n.job_unverified {\n    text-align: center;\n\n    h1 {\n        font-size: 33px;\n        font-weight: 600;\n        margin-bottom: 5px;\n    }\n\n    h2 {\n        font-size: 25px;\n        font-weight: 400;\n    }\n\n    p {\n        font-size: 17px;\n    }\n\n    button {\n        display: block;\n        margin: 25px auto 0;\n    }\n}\n.job_info_modal {\n    .ant-modal-content {\n        @media screen and (max-width: $desktop) {\n            overflow-x: scroll;\n        }\n    }\n}\n.createTest {\n    h1 {\n        font-size: 30px;\n        font-weight: 600;\n        margin-bottom: 5px;\n    }\n    h6 {\n        font-size: 15px;\n        font-weight: 400;\n    }\n\n    .platform_btn {\n        width: 100%;\n        margin-top: 10px;\n    }\n\n    &_block {\n        position: relative;\n        padding: 20px;\n        margin-bottom: 10px;\n        border-radius: 5px;\n        background-color: rgba(122, 201, 238, 0.384);\n\n        &_delete {\n            position: absolute;\n            top: 10px;\n            right: 20px;\n        }\n\n        &_answer {\n            margin: 10px 0;\n            padding: 5px;\n            display: flex;\n            align-items: center;\n\n            b {\n                font-size: 23px;\n                // margin-right: 10px;\n            }\n        }\n    }\n\n    &_add {\n        margin-top: 20px;\n        border-radius: 5px;\n        background-color: rgba(122, 201, 238, 0.384);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n\n        transition: 0.2s all ease-in-out;\n\n        &:hover {\n            transition: 0.2s all ease-in-out;\n            background-color: rgba(63, 164, 211, 0.384);\n        }\n\n        b {\n            font-size: 40px;\n            margin: 0;\n            font-weight: 400;\n            color: $font-clor;\n            line-height: 1;\n            display: flex;\n            align-items: center;\n\n            span {\n                font-size: 20px;\n                margin-left: 20px;\n            }\n        }\n    }\n}\n.edit-test {\n    position: relative;\n    height: 100% !important;\n    min-height: 78vh;\n    h1 {\n        font-size: 30px;\n        font-weight: 600;\n        margin-bottom: 5px;\n    }\n    h6 {\n        font-size: 15px;\n        font-weight: 400;\n    }\n}\n\n.cources {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    min-height: 78vh;\n    height: 100%;\n\n    &_top {\n        display: flex;\n        padding: 20px 20px 0;\n        justify-content: space-between;\n        margin-bottom: 40px;\n        flex-wrap: wrap;\n\n        .ant-progress {\n            width: 70%;\n\n            @media screen and (max-width: 1000px) {\n                width: 100%;\n                margin-bottom: 20px;\n            }\n        }\n    }\n\n    &_nav {\n        width: 20%;\n        border-right: 1px solid rgba(128, 128, 128, 0.473);\n\n        @media screen and (max-width: 1000px) {\n            display: none;\n        }\n\n        a {\n            display: block;\n            font-size: 15px;\n            font-weight: 400;\n            margin-bottom: 12px;\n            color: $font-color-grey;\n\n            &.active {\n                color: $font-clor;\n            }\n        }\n    }\n\n    &_content {\n        width: 80%;\n\n        @media screen and (max-width: 1000px) {\n            width: 100%;\n        }\n    }\n\n    &_wrap {\n        display: flex;\n        flex-wrap: wrap;\n        padding: 0 20px;\n        gap: 10px;\n    }\n}\n.cource_item {\n    margin-bottom: 20px;\n    width: calc((100% - 20px) / 3);\n    cursor: pointer;\n\n    @media screen and (max-width: 1000px) {\n        width: 49%;\n    }\n\n    @media screen and (max-width: 769px) {\n        width: 100%;\n    }\n\n    &:hover {\n        h1 {\n            color: $font-clor;\n            transition: 0.3s color ease-in-out;\n        }\n    }\n\n    h1 {\n        font-size: 22px;\n        margin-bottom: 5px;\n        text-align: center;\n        transition: 0.3s color ease-in-out;\n\n        @media screen and (max-width: 769px) {\n            font-size: 18px;\n        }\n    }\n\n    img {\n        height: 150px;\n        width: 100%;\n        border-radius: 10px;\n\n        @media screen and (max-width: 1000px) {\n            height: 200px;\n        }\n        @media screen and (max-width: 769px) {\n            height: 200px;\n            object-fit: cover;\n        }\n    }\n}\n.course {\n    padding: 0 20px;\n\n    &_top {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    h1 {\n        font-size: 26px;\n        width: auto;\n        margin-bottom: 0;\n\n        @media screen and (max-width: 769px) {\n            font-size: 17px;\n            width: 100%;\n            margin-bottom: 10px;\n        }\n    }\n\n    button {\n        @media screen and (max-width: 769px) {\n            margin-bottom: 10px;\n        }\n    }\n\n    iframe {\n        @media screen and (max-width: 769px) {\n            height: 300px !important;\n        }\n    }\n\n    object {\n        @media screen and (max-width: 769px) {\n            height: 600px !important;\n        }\n    }\n\n    &_navigation_element {\n        display: flex;\n        align-items: center;\n        span {\n            margin-left: 10px;\n        }\n    }\n}\n.test {\n    min-height: 400px;\n\n    &_header {\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n        padding: 20px;\n        background-color: $font-clor;\n        border-radius: 20px 20px 0 0;\n\n        @media screen and (max-width: 769px) {\n            padding: 5px;\n        }\n\n        h1 {\n            color: white;\n            font-size: 25px;\n            margin-bottom: 10px;\n            font-weight: 700;\n            width: 100%;\n            text-align: center;\n\n            @media screen and (max-width: 700px) {\n                font-size: 17px;\n            }\n        }\n    }\n\n    &_main {\n        h2 {\n            font-weight: 500;\n            margin-top: 50px;\n            font-size: 30px;\n            text-align: center;\n\n            @media screen and (max-width: 700px) {\n                font-size: 17px;\n            }\n        }\n        &_answers {\n            display: flex;\n            flex-wrap: wrap;\n            justify-content: space-between;\n\n            button span {\n                @media screen and (max-width: 700px) {\n                    font-size: 14px;\n                }\n            }\n        }\n\n        img:not(.preloader) {\n            width: 100%;\n            // object-fit: cover;\n            max-height: 450px;\n        }\n    }\n\n    &_footer {\n        display: flex;\n        justify-content: flex-end;\n        margin-top: 20px;\n        margin-bottom: 40px;\n\n        .platform_btn {\n            width: 50%;\n        }\n    }\n}\n\n.questionItem {\n    padding: 20px;\n    display: flex;\n    align-items: center;\n    width: 48%;\n}\n\n.checkbox {\n    width: 48%;\n\n    &_btn {\n        width: 100%;\n        transition: 0.2s all ease-in-out;\n        font-size: 20px;\n        display: flex;\n        align-items: center;\n        border: 2px solid rgba(120, 231, 120, 0.11);\n        margin-top: 20px;\n        border-radius: 5px;\n        padding: 20px;\n        cursor: pointer;\n\n        &.active {\n            border: 2px solid $font-clor;\n            background-color: $font-clor;\n\n            b,\n            span {\n                color: white;\n            }\n        }\n\n        b {\n            transition: 0.2s all ease-in-out;\n            font-weight: 700;\n            font-size: 25px;\n            color: $font-clor;\n            margin-right: 20px;\n        }\n\n        span {\n            transition: 0.2s all ease-in-out;\n            font-weight: 500;\n            font-size: 18px;\n        }\n    }\n}\n\n.ant-steps-item-finish .ant-steps-item-icon {\n    background: $font-clor;\n    border-color: $font-clor;\n}\n.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {\n    color: white;\n    &_content {\n        width: 80%;\n    }\n\n    &_wrap {\n        display: flex;\n        flex-wrap: wrap;\n        padding: 0 20px;\n        gap: 10px;\n    }\n}\n.finish-test {\n    padding: 50px 0;\n    text-align: center;\n\n    svg {\n        display: block;\n        margin: 0 auto 40px;\n    }\n    h1 {\n        font-weight: 700;\n        font-size: 36px;\n        line-height: 42px;\n        text-align: center;\n        color: $font-color-grey;\n        margin-bottom: 35px;\n    }\n\n    h2 {\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 19px;\n        text-align: center;\n        color: $font-color-grey;\n        margin-bottom: 30px;\n    }\n\n    p {\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 19px;\n        text-align: center;\n        max-width: 310px;\n        margin: 0 auto 30px;\n    }\n\n    button {\n        margin: 0 auto;\n        display: block;\n    }\n}\n.test_wrapepr {\n    width: 100%;\n    margin: 0px auto;\n\n    .wrapper_for_blocks {\n        @media screen and (max-width: 700px) {\n            padding: 0 0 15px 0;\n        }\n    }\n\n    .test_footer {\n        button {\n            @media screen and (max-width: 700px) {\n                margin-right: 10px;\n            }\n        }\n    }\n}\n.modal-test {\n    .ant-modal-body {\n        padding: 0;\n        border-radius: 10px;\n    }\n}\n\n.verification {\n    border-radius: 10px;\n    background: var(--white, #fff);\n    box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.15);\n    padding: 24px 32px;\n\n    & p a {\n        color: $font-clor;\n    }\n\n    h2 {\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 19px;\n        color: $font-color-grey;\n        margin-bottom: 20px;\n    }\n\n    h3 {\n        font-weight: 500;\n        font-size: 15px;\n        line-height: 18px;\n        color: $font-color-grey;\n        margin-bottom: 15px;\n    }\n\n    &_steps {\n        margin-top: 25px;\n        .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {\n            background-color: #ffa500 !important;\n            border-color: #ffa500 !important;\n        }\n\n        .ant-steps-item-description {\n            max-width: 90px !important;\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 14px;\n            color: #aeaeae;\n        }\n    }\n\n    &_step {\n        display: flex;\n        flex-wrap: wrap;\n        margin-top: 50px;\n    }\n\n    &_nav {\n        display: flex;\n        margin-top: 20px;\n\n        button {\n            margin-right: 25px;\n        }\n    }\n\n    &_completed {\n        padding: 50px;\n        text-align: center;\n\n        h1 {\n            font-weight: 500;\n            font-size: 24px;\n            line-height: 28px;\n            color: $font-color-grey;\n            margin-bottom: 15px;\n        }\n\n        h3 {\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 19px;\n            color: $font-color-grey;\n        }\n\n        img {\n            margin: 35px 0;\n        }\n    }\n\n    .w8 {\n        margin-top: 25px;\n\n        button {\n            margin-right: 15px;\n        }\n    }\n}\n.w8-message {\n    max-height: 200px;\n    text-align: center;\n\n    h1 {\n        font-size: 23px;\n        margin-bottom: 0;\n        margin-top: 20px;\n\n        @media screen and (max-width: $desktop) {\n            font-size: 18px;\n        }\n    }\n}\n.decline {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 20;\n    // filter: blur(300px);\n    background-color: rgba(136, 135, 135, 0.548);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .ant-collapse {\n        max-width: 70%;\n        margin: 0 auto 20px;\n    }\n\n    &_content {\n        width: 65%;\n        height: auto;\n        background-color: white;\n        border-radius: 20px;\n        box-shadow: $shadow;\n        padding: 100px 25px;\n        text-align: center;\n\n        h1 {\n            font-weight: 700;\n            font-size: 32px;\n            line-height: 38px;\n            color: $font-color-grey;\n        }\n\n        &_img {\n            margin: 90px 0;\n        }\n\n        h6 {\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 19px;\n            color: $font-color-grey;\n            max-width: 480px;\n            margin: 0 auto;\n            margin-bottom: 20px;\n        }\n    }\n}\n.privacy {\n    padding-bottom: 15px;\n    small {\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 16px;\n        color: #aeaeae;\n        margin-bottom: 45px;\n        display: block;\n    }\n\n    h1 {\n        font-weight: 700;\n        font-size: 20px;\n        line-height: 23px;\n        color: #000000;\n    }\n\n    b {\n        &.link {\n            color: $font-clor;\n        }\n\n        &.doc {\n            background-color: yellow;\n        }\n    }\n\n    h2 {\n        margin-top: 30px;\n        font-weight: 700;\n        font-size: 20px;\n        line-height: 23px;\n        color: #000000;\n    }\n}\n\n.withdrawal {\n    &_table {\n        .email {\n            color: $font-clor;\n            font-weight: 600;\n            font-size: 16px;\n            line-height: 19px;\n        }\n\n        .ant-table {\n            background: none !important;\n        }\n        .ant-table-thead {\n            background-color: transparent;\n\n            .ant-table-cell {\n                font-weight: 400;\n                font-size: 16px;\n                line-height: 19px;\n                color: #aeaeae;\n            }\n        }\n        .ant-table-thead > tr > th {\n            background-color: transparent !important;\n            border-bottom: none;\n        }\n\n        .ant-table-tbody {\n            .ant-table-cell {\n                font-weight: 400;\n                font-size: 16px;\n                line-height: 19px;\n                color: $font-color-grey;\n                border-bottom: 1px solid #aeaeae;\n                padding-top: 10px;\n                padding-bottom: 10px;\n\n                .username {\n                    font-weight: 700;\n                    font-size: 16px;\n                    line-height: 19px;\n                }\n            }\n        }\n    }\n}\n.document_information {\n    padding: 35px 45px 0;\n\n    h1 {\n        font-weight: 500;\n        font-size: 20px;\n        line-height: 23px;\n        color: $font-color-grey;\n        margin-bottom: 40px;\n    }\n\n    .ant-timeline-item-content {\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 19px;\n        color: $font-color-grey;\n    }\n\n    .ant-timeline-item-tail {\n        border-left: 1px dashed #00955f;\n    }\n}\n.files_wrap {\n    display: flex;\n\n    .ant-upload-picture-card-wrapper {\n        width: auto;\n    }\n}\n\n.overview {\n    text-align: center;\n\n    &_empty {\n        margin: 0 auto;\n        text-align: center;\n\n        svg {\n            margin-bottom: 40px;\n        }\n\n        &_title {\n            font-size: 18px;\n            font-weight: 500;\n            margin-bottom: 15px;\n            display: block;\n            color: #6b6b6b;\n        }\n        &_description {\n            font-size: 16px;\n            font-weight: 400;\n            margin-bottom: 30px;\n            display: block;\n            color: #6b6b6b;\n        }\n\n        button {\n            a {\n                // color: white;\n            }\n        }\n    }\n\n    &_title {\n        display: block;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 19px;\n        color: $font-color-grey;\n        margin-bottom: 40px;\n    }\n\n    button {\n        margin: 0 auto;\n    }\n\n    &_note {\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 16px;\n        text-align: center;\n        color: #aeaeae;\n        margin-top: 25px;\n        display: block;\n    }\n\n    &_projects {\n        margin-bottom: -40px;\n\n        @media screen and (max-width: 768px) {\n            margin-bottom: 0px;\n        }\n\n        h6 {\n            font-weight: 500;\n            font-size: 18px;\n            line-height: 21px;\n            color: $font-color-grey;\n            margin-bottom: 40px;\n        }\n\n        &_wrap {\n            display: flex;\n            justify-content: space-between;\n            flex-wrap: wrap;\n            margin-bottom: 35px;\n        }\n\n        &_wrap_top {\n            display: flex;\n            justify-content: space-between;\n            flex-wrap: wrap;\n            width: 100%;\n        }\n\n        .flex {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            margin-bottom: 15px;\n        }\n\n        &_item {\n            background: #ffffff;\n            box-shadow: 0px 10px 50px -15px rgba(132, 132, 132, 0.5);\n            border-radius: 5px;\n            padding: 25px 30px;\n            width: 48%;\n            margin-bottom: 30px;\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n\n            @media screen and (max-width: 1024px) {\n                width: 100%;\n                padding: 5px 20px;\n            }\n\n            @media screen and (max-width: 768px) {\n                padding: 5px;\n            }\n\n            @media screen and (max-width: 768px) {\n                padding-bottom: 15px;\n            }\n\n            h5 {\n                font-weight: 500;\n                font-size: 18px;\n                line-height: 21px;\n                color: $font-color-grey;\n                margin-bottom: 20px;\n            }\n\n            img {\n                max-width: 140px;\n                max-height: 80px;\n                border-radius: 2px;\n                width: 33%;\n                margin-bottom: 5px;\n\n                @media screen and (max-width: 1024px) {\n                    max-width: 100%;\n                    width: 100%;\n                    object-fit: cover;\n                    margin-bottom: 10px;\n                }\n            }\n\n            &_info {\n                margin-left: 15px;\n                width: calc(100% - 33% - 15px);\n\n                @media screen and (max-width: 1024px) {\n                    width: 100%;\n                    margin-left: 0;\n                }\n\n                b {\n                    font-weight: 500;\n                    font-size: 14px;\n                    line-height: 16px;\n                    color: $font-color-grey;\n                    width: 45%;\n\n                    @media screen and (max-width: 768px) {\n                        font-size: 14px;\n                    }\n\n                    @media screen and (max-width: 1024px) {\n                        width: 36%;\n                    }\n                }\n\n                span {\n                    font-weight: 400;\n                    font-size: 14px;\n                    line-height: 16px;\n                    color: #898989;\n                    width: 55%;\n\n                    @media screen and (max-width: 768px) {\n                        font-size: 14px;\n                    }\n\n                    @media screen and (max-width: 1024px) {\n                        width: 70%;\n                    }\n                }\n            }\n        }\n\n        &_content {\n\n            max-width: 100%;\n\n            &_item {\n                display: flex;\n                justify-content: space-between;\n                margin-bottom: 15px;\n            }\n            &_item:last-child {\n                margin-bottom: 0;\n                opacity: 0.4;\n\n                b {\n                    font-size: 12px;\n                    font-weight: 500;\n                }\n                span {\n                    font-size: 12px;\n                    font-weight: 400;\n                }\n            }\n            b {\n                font-weight: 500;\n                font-size: 14px;\n                line-height: 16px;\n                color: $font-color-grey;\n                width: 33%;\n            }\n\n            span {\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 16px;\n                color: #898989;\n                width: 66%;\n                display: flex;\n                align-items: center;\n\n                svg{\n                    margin-left: 10px;\n                }\n            }\n        }\n\n        button {\n            margin: 0 auto;\n        }\n    }\n}\n\n.our {\n    max-width: calc((100% / 2) - 9px) !important;\n\n    @media screen and (max-width: 1024px) {\n        max-width: 100% !important;\n    }\n}\n\n.faq {\n    @media screen and (max-width: 689px) {\n        padding-bottom: 50px;\n    }\n\n    &_top {\n        border-radius: 10px;\n        background: #d0ece4;\n        box-shadow: 0px 5px 20px 0px rgba(12, 64, 49, 0.15);\n        padding: 45px 0;\n        text-align: center;\n        margin-bottom: 50px;\n        width: 100%;\n\n        @media screen and (max-width: 830px) {\n            padding: 15px 0;\n        }\n\n        h2 {\n            font-size: 28px;\n            font-weight: 500;\n            color: $font-color-grey;\n            margin-bottom: 35px;\n\n            @media screen and (max-width: 830px) {\n                font-size: 22px;\n                margin-bottom: 15px;\n            }\n        }\n        .ant-input-affix-wrapper {\n            max-width: 750px;\n            border-radius: 20px;\n\n            @media screen and (max-width: 830px) {\n                max-width: 90%;\n            }\n        }\n    }\n    &_footer {\n        text-align: center;\n        max-width: 440px;\n        margin: 0 auto;\n\n        button {\n            margin: 0 auto;\n        }\n\n        h3 {\n            font-size: 28px;\n            font-weight: 500;\n            color: #aeaeae;\n            margin-bottom: 15px;\n\n            @media screen and (max-width: 830px) {\n                font-size: 21px;\n            }\n        }\n        p {\n            font-size: 16px;\n            color: #aeaeae;\n            margin: 0px 0 30px;\n\n            @media screen and (max-width: 830px) {\n                font-size: 14px;\n            }\n        }\n    }\n    &_content {\n        display: flex;\n        justify-content: space-between;\n        flex-wrap: wrap;\n        margin-bottom: 100px;\n\n        @media screen and (max-width: 830px) {\n            margin-bottom: 50px;\n        }\n\n        &_nav {\n            max-width: 270px;\n            width: 100%;\n            padding: 32px 24px;\n            background: #ffffff;\n            box-shadow: 0px 10px 50px -15px rgba(132, 132, 132, 0.3);\n            border-radius: 20px;\n            height: fit-content;\n\n            @media screen and (max-width: 689px) {\n                margin: 0 auto 20px;\n            }\n\n            ul {\n                padding: 0;\n                margin-bottom: 0;\n            }\n            li {\n                list-style-type: none;\n                font-weight: 400;\n                font-size: 16px;\n                line-height: 16px;\n                color: $font-color-grey;\n                margin-bottom: 30px;\n                cursor: pointer;\n                transition: 0.2 all cubic-bezier(0.075, 0.82, 0.165, 1);\n                position: relative;\n                &:hover {\n                    opacity: 0.5;\n                    transition: 0.2 all cubic-bezier(0.075, 0.82, 0.165, 1);\n                }\n                &.active {\n                    color: $font-clor;\n                    font-weight: 400;\n\n                    &:before {\n                        content: \"\";\n                        position: absolute;\n                        left: -24px;\n                        top: 0;\n                        bottom: 0;\n                        width: 6px;\n                        background: #00955f;\n                        border-radius: 0px 2px 2px 0px;\n                    }\n                }\n\n                &:last-of-type {\n                    margin-bottom: 0;\n                }\n            }\n        }\n        &_main {\n            width: calc(100% - 300px);\n\n            @media screen and (max-width: 689px) {\n                width: 100%;\n            }\n\n            .ant-collapse {\n                border: none;\n            }\n            .ant-collapse-item {\n                border: none;\n                margin-bottom: 15px;\n            }\n            .ant-collapse-header {\n                padding: 30px 40px !important;\n                background: #ffffff;\n                box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.15);\n                border-radius: 10px !important;\n                font-weight: 400;\n                font-size: 16px;\n                color: $font-color-grey;\n\n                p {\n                    margin-bottom: 0;\n                    padding-right: 21px;\n                }\n\n                @media screen and (max-width: 830px) {\n                    padding: 16px 20px !important;\n                }\n            }\n            .anticon {\n                background: #d0ece4;\n                color: $font-clor;\n                padding: 10px;\n                border-radius: 100px;\n                position: absolute;\n                right: 16px;\n\n                @media screen and (max-width: 576px) {\n                    right: 0;\n                }\n            }\n            .ant-collapse-content {\n                border: none;\n                border-radius: 20px !important;\n                padding-top: 10px;\n\n                p {\n                    margin-bottom: 0;\n                }\n            }\n            .ant-collapse-content-box {\n                padding: 30px 40px !important;\n                border: none;\n                box-shadow: 0px 10px 50px -15px rgba(132, 132, 132, 0.3);\n\n                p {\n                    font-weight: 400;\n                    font-size: 16px;\n                    color: $font-color-grey;\n                }\n\n                @media screen and (max-width: 830px) {\n                    padding: 16px 20px !important;\n\n                    p {\n                        font-size: 15px;\n                    }\n                }\n            }\n        }\n    }\n    &_empty {\n        text-align: center;\n        max-width: 340px;\n        margin: 20px auto;\n\n        h2 {\n            margin: 32px 0 16px;\n        }\n\n        p {\n            color: $font-color-grey;\n            font-size: 16px;\n            margin-bottom: 0;\n        }\n    }\n}\n.highlight {\n    color: #ffb12b;\n    font-weight: 400;\n    font-size: 16px;\n}\n.unenroll {\n    margin-bottom: 27px;\n}\n.project_active {\n    margin-bottom: 5px;\n    display: flex;\n    align-items: center;\n\n    button {\n        border: 1px solid #f00 !important;\n        color: #f00 !important;\n    }\n\n    h1 {\n        font-size: 32px;\n        font-style: normal;\n        font-weight: 500;\n        color: $font-color-grey;\n        margin-bottom: 0;\n        margin-right: 30px;\n\n        @media screen and (max-width: 1024px) {\n            font-size: 22px;\n        }\n    }\n}\n.verification_center {\n    h1 {\n        color: #6b6b6b;\n        font-size: 32px;\n        font-weight: 500;\n        line-height: normal;\n        margin-bottom: 38px;\n\n        @media screen and (max-width: 1024px) {\n            font-size: 22px;\n        }\n    }\n}\n\n.fee{\n    margin: 20px auto 20px;\n    text-align: center;\n  \n    p{\n      font-size: 16px;\n      font-weight: 400;\n    }\n  \n    b{\n      color: $font-clor;\n      font-weight: 700;\n    }\n  }\n\n  .add-routing{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 25px;\n    width: 25px;\n    margin-left: 15px;\n    border: 2px solid $font-clor;\n    color: $font-clor;\n    border-radius: 100%;\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 21px;\n  }","$main: rgba(1, 83, 34, 0.7);\n$background: #fbfbfb;\n$white-color: #ffffff;\n$header-background: white;\n$font-clor: #00955f;\n$font-color-grey: #6b6b6b;\n$shadow: 0px 10px 50px -15px rgba(132, 132, 132, 0.3);\n$border-radius-btn: 20px;\n$shadow-btn: 0px 10px 12px -6px #3d9877;\n\n$grey-background: #f1f1f1;\n$grey-color: #757575;\n$blue-background: #46a6ff;\n\n:export {\n    color: $main;\n}\n\n$width_auth_description_block: 275px;\n// $retina: \"(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)\";\n\n$mobile: 320px;\n$tablet: 768px;\n$desktop: 1000px;\n\n$default-btn: #00955f;\n$default-btn-hover: #0ab475;\n$danger-btn:  #9c0e0e;\n$danger-btn-hover: #ff0000;\n$primary-btn: #4285f4;\n$primary-btn-hover: #276ad9;\n\n@mixin default-button {\n    outline: none;\n    border: none;\n    transition: 0.3s all ease-in-out;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    box-shadow: $shadow-btn;\n    cursor: pointer;\n    font-family: \"Roboto\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 19px;\n    border-radius: 20px;\n    position: relative;\n}\n\n@mixin green-hover {\n    transition: 0.3s all ease-in-out;\n    background: $green-gradient-hover;\n    color: #ffffff;\n}\n\n@mixin green-focus {\n    @include green-hover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `rgba(1, 83, 34, 0.7)`
};
export default ___CSS_LOADER_EXPORT___;
